export default "__VITE_ASSET__DodfjDj6__"